import React, { useEffect, useState } from "react";
import "../css/MyListings.css";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import NavbarComponent from "./Navbar";
import FooterComponent from "./Footer";
import { COMMON_CONSTANTS } from '../constants/Common'
import { AXIOS_HELPERS } from "../helpers/Axios";

const { config: { base_url } } = COMMON_CONSTANTS
const { MakeAxiosCall } = AXIOS_HELPERS

// const base_url = process.env.REACT_APP_API_BASE_URL
// const base_url = "https://www.codingsikho.online/api/v1"



const MyListings = () => {
  const [listings, setListings] = useState([]);
  const navigate = useNavigate()


  useEffect(() => {

    const { userId = null } = JSON.parse(localStorage.getItem('user')) || {}
    const fetchLands = async () => {
      try {
        const options = {
          method: "GET",
          url: `${base_url}/getlands`,
          headers: {
            "Content-Type": "application/json",
            ...(userId && { userId })
          }
        }

        const response = await MakeAxiosCall(options)
        if (response?.data?.data.status) {
          setListings(response.data.data.data)
        }
      } catch (error) {
        console.log('error', error)
        if (error?.response?.data?.statusCode === 401) {
          localStorage.clear()
          navigate('/login')
          // Logout('/login')
        }

      }

    }
    fetchLands()

  }, [navigate])


  const handleEdit = (eachLand) => {
    // console.log('each land========', eachLand)
    alert(`Aru sure to Edit this land:`);
    navigate('/update-land', { state: { eachLand } })
  };

  const handleDelete = async (_id) => {
    // console.log('======id', _id)
    const { userId = null } = JSON.parse(localStorage.getItem('user')) || {}
    const options = {
      method: "DELETE",
      url: `${base_url}/delete-land`,
      headers: {
        "Content-Type": "application/json",
        ...(userId && { userId })
      },
      params: {
        _id
      }
    }
    const confirmDelete = window.confirm("Are you sure you want to delete this property?");
    if (confirmDelete) {
      const response = await MakeAxiosCall(options)
      // console.log('delete response========', response.data)
      if (response?.data?.data.status) {
        setListings(response.data.data.data)
      }
      setListings(listings.filter((listing) => listing._id !== _id));
    }
  };

  return (
    <>
      <NavbarComponent />
      <div className="listings-container">
        <h1 className="listings-header">My Listings</h1>
        <table className="listings-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Land Type</th>
              <th>Transaction Type</th>
              <th>Address</th>
              <th>Pincode</th>
              <th>Total Area</th>
              <th>Price per Acer</th>
              <th>Listed Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {listings.length > 0 ? (
              listings.map((listing) => (
                <tr key={listing._id}>
                  <td>
                    <img
                      src={listing.imageUrl || '/placeholder-image.png'} // Replace `imageUrl` with the actual key for the image URL
                      alt="Land"
                      className="land-image"
                    />
                  </td>
                  <td>{listing.landType}</td>
                  <td>{listing.transactionType}</td>
                  <td>{listing.address}</td>
                  <td>{listing.pincode}</td>
                  <td>{listing.area}</td>
                  <td>{listing.pricePerAcer}</td>
                  <td>{new Date(listing.createdAt).toLocaleString()}</td>
                  <td className={listing.status === "Active" ? "status-active" : "status-pending"}>
                    {listing.status}
                  </td>
                  <td>
                    <button  onClick={() => handleEdit(listing)} className="action-button edit-button">
                      Edit
                    </button>
                    <button onClick={() => handleDelete(listing._id)} className="action-button delete-button">
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-listings">No listings available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <FooterComponent />
    </>
  );
};

export default MyListings;
